import { create } from "zustand";

type AnimationState = {
  isVisible: boolean;
  showAnimation: () => void;
  hideAnimation: () => void;
};

export const useAnimationStore = create<AnimationState>((set) => ({
  isVisible: false,
  animationConfig: null,
  showAnimation: () => set({ isVisible: true }),
  hideAnimation: () => set({ isVisible: false }),
}));
